<div class="page-title-right">
  <ol class="breadcrumb m-0">
    <li class="breadcrumb-item"><a routerLink="/admin/bio">Bio</a></li>
    <li class="breadcrumb-item active">Links</li>
  </ol>
</div>

<div class="d-flex align-items-center justify-content-between mb-2">
  <h4 class="page-title mb-0">
    <i class="fas fa-link mr-2"></i>
    MeuCardápio Bio - Links
  </h4>
</div>

<div class="text-center p-5" *ngIf="carregando">
  <div class="k-i-loading" style="font-size: 40px;"></div>
</div>

<div class="card" *ngIf="!carregando && !idBioPagina">
  <div class="card-body text-center p-5">
    <i class="fas fa-exclamation-triangle fa-3x text-warning mb-3"></i>
    <p class="text-muted">Configure primeiro a página Bio em "Configurações" antes de adicionar itens.</p>
    <a routerLink="/admin/bio/configuracoes" class="btn btn-primary">
      <i class="fas fa-cog mr-1"></i> Ir para Configurações
    </a>
  </div>
</div>

<div class="bio-layout" *ngIf="!carregando && idBioPagina">
  <div class="form-panel">
    <div class="d-flex justify-content-end mb-3">
      <button class="btn btn-primary btn-add-link" (click)="novoItem()">
        <i class="fas fa-plus mr-1"></i> Adicionar Item
      </button>
    </div>

    <div class="card" *ngIf="links.length === 0">
      <div class="card-body text-center p-5">
        <i class="fas fa-link fa-3x text-muted mb-3"></i>
        <h5 class="text-muted">Nenhum item cadastrado</h5>
        <p class="text-muted">Adicione links e separadores para organizar melhor sua bio.</p>
        <button class="btn btn-primary" (click)="novoItem()">
          <i class="fas fa-plus mr-1"></i> Adicionar Primeiro Item
        </button>
      </div>
    </div>

    <div *ngIf="links.length > 0">
      <div cdkDropList (cdkDropListDropped)="onDrop($event)" [cdkDropListDisabled]="linkExpandido !== null" class="links-list">
        <div class="link-card card mb-2"
             *ngFor="let link of links; let i = index"
             [class.expandido]="linkExpandido === obtenhaChave(link, i)"
             [class.nao-salvo]="!link.id"
             cdkDrag
             [cdkDragDisabled]="linkExpandido !== null">

          <div class="link-row" *ngIf="linkExpandido !== obtenhaChave(link, i)">

            <div class="link-row__drag" cdkDragHandle>
              <i class="fas fa-grip-vertical"></i>
            </div>

            <div class="link-row__media">
              <div class="link-row__thumb" *ngIf="temImagemDoLink(link)">
                <img [src]="obtenhaUrlImagemDoLink(link)" alt="" />
              </div>
              <div class="link-row__icon"
                   *ngIf="!temImagemDoLink(link)"
                   [style.backgroundColor]="obtenhaFundoDecorativoDoLink(link)">
                <img *ngIf="obtenhaImagemDoIcone(link)"
                     [src]="obtenhaImagemDoIcone(link)" alt="" />
                <i *ngIf="!obtenhaImagemDoIcone(link)"
                   [class]="obtenhaIconeSelecionado(link) || obtenhaIconeDoTipo(link.tipo, link.itemType || 'link')"
                   [style.color]="obtenhaCorDecorativaDoLink(link)"></i>
              </div>
            </div>

            <div class="link-row__body" (click)="editarLink(link, i)">
              <div class="link-row__top">
                <span class="link-row__type"
                      [style.color]="obtenhaCorDoTipo(link.tipo, link.itemType || 'link')">
                  {{obtenhaLabelDoTipo(link.tipo, link.itemType || 'link')}}
                </span>
                <span class="badge badge-warning ml-1" *ngIf="!link.id">Não salvo</span>
              </div>
              <strong class="link-row__title">{{obtenhaTituloCompacto(link)}}</strong>
              <div class="link-row__meta">
                <span *ngIf="isSeparador(link)">{{obtenhaResumoSeparador(link)}}</span>
                <ng-container *ngIf="!isSeparador(link)">
                  <span *ngIf="link.subtitulo">{{link.subtitulo}}</span>
                  <span class="link-row__url" *ngIf="link.url">{{link.url}}</span>
                </ng-container>
              </div>
              <span class="badge-etiqueta mt-1" *ngIf="!isSeparador(link) && link.etiqueta"
                    [style.backgroundColor]="corPrimaria || '#E53935'"
                    [style.color]="'white'">
                <i class="fas fa-tag"></i>{{link.etiqueta}}
              </span>
            </div>

            <div class="link-row__actions">
              <kendo-switch [ngModel]="link.ativo"
                            (valueChange)="toggleAtivoLink(link, $event)">
              </kendo-switch>
              <button class="link-row__btn" (click)="editarLink(link, i)" title="Editar">
                <i class="fas fa-pencil-alt"></i>
              </button>
              <button class="link-row__btn link-row__btn--danger" (click)="confirmarExclusao(link)" title="Excluir">
                <i class="fas fa-trash"></i>
              </button>
            </div>

          </div>

          <div class="card-body" *ngIf="linkExpandido === obtenhaChave(link, i)">
            <div class="link-editor">
              <div class="link-editor__hero">
                <div class="link-editor__identity">
                  <div class="link-icon link-editor__icon"
                       [style.backgroundColor]="obtenhaFundoDecorativoDoLink(link)"
                       [style.borderColor]="obtenhaBordaDecorativaDoLink(link)"
                       [style.color]="obtenhaCorDecorativaDoLink(link)">
                    <img *ngIf="temImagemDoLink(link)"
                         [src]="obtenhaUrlImagemDoLink(link)"
                         class="link-thumb-destaque"
                         alt="" />
                    <img *ngIf="exibeLogoDoLink(link)"
                         [src]="obtenhaImagemDoIcone(link)"
                         class="link-tipo-logo"
                         [alt]="obtenhaLabelDoTipo(link.tipo, link.itemType || 'link')" />
                    <i *ngIf="!temImagemDoLink(link) && !exibeLogoDoLink(link)"
                       [class]="obtenhaIconeDoLink(link)"></i>
                  </div>

                  <div class="link-editor__title-block">
                    <div class="link-editor__meta">
                      <span class="badge badge-tipo"
                            [style.backgroundColor]="obtenhaCorDoTipo(link.tipo, link.itemType || 'link') + '20'"
                            [style.color]="obtenhaCorDoTipo(link.tipo, link.itemType || 'link')">
                        {{obtenhaLabelDoTipo(link.tipo, link.itemType || 'link')}}
                      </span>
                      <span class="badge badge-warning" *ngIf="!link.id">Não salvo</span>
                    </div>
                    <h5 class="link-editor__headline mb-0">{{obtenhaTituloCompacto(link) || 'Novo item da bio'}}</h5>
                    <p class="link-editor__subhead mb-0" *ngIf="!isSeparador(link)">Edite o conteúdo principal, o destino do clique e os elementos de destaque do card.</p>
                    <p class="link-editor__subhead mb-0" *ngIf="isSeparador(link)">Organize a bio em blocos com um separador visual limpo e fácil de escanear.</p>
                  </div>
                </div>

                <div class="link-editor__state">
                  <span class="link-editor__state-label">Status</span>
                  <strong class="link-editor__state-value">{{link.ativo ? 'Ativo' : 'Pausado'}}</strong>
                  <kendo-switch [ngModel]="link.ativo" (valueChange)="toggleAtivoLink(link, $event)"></kendo-switch>
                </div>
              </div>

              <ng-container *ngIf="!isSeparador(link)">
                <div class="link-editor__section">
                  <div class="link-editor__section-head">
                    <div>
                      <span class="link-editor__eyebrow">Essencial</span>
                      <strong class="link-editor__section-title">Conteúdo principal</strong>
                    </div>
                  </div>

                  <div class="link-editor__grid">
                    <div class="form-group mb-0 link-editor__field link-editor__field--title">
                      <label class="link-editor__label">Título</label>
                      <input class="form-control link-editor__input" [(ngModel)]="link.titulo" placeholder="Título do link">
                    </div>

                    <div class="form-group mb-0 link-editor__field link-editor__field--url">
                      <label class="link-editor__label">URL</label>
                      <input class="form-control link-editor__input" [(ngModel)]="link.url" [placeholder]="placeholderUrl(link.tipo)">
                    </div>

                    <div class="form-group mb-0 link-editor__field">
                      <label class="link-editor__label">Subtítulo</label>
                      <input class="form-control link-editor__input" [(ngModel)]="link.subtitulo" placeholder="Ex: Entrega grátis acima de R$ 50">
                      <small class="link-editor__help">Apoio curto que ajuda a explicar o clique.</small>
                    </div>

                    <div class="form-group mb-0 link-editor__field">
                      <label class="link-editor__label">Etiqueta / Badge</label>
                      <input class="form-control link-editor__input" [(ngModel)]="link.etiqueta" placeholder="Ex: Mais barato que no iFood!">
                      <small class="link-editor__help">Texto curto em destaque acima do link.</small>
                    </div>

                    <div class="form-group mb-0 link-editor__field link-editor__field--full">
                      <label class="link-editor__label">Miniatura do link</label>
                      <div class="link-mode-tiles">

                        <button type="button"
                                class="link-mode-tile"
                                [class.is-active]="usarIconeNoLink(link)"
                                (click)="selecionarModoVisual(link, 'icon')">
                          <div class="link-mode-tile__header">
                            <span class="link-mode-tile__radio"></span>
                            <span class="link-mode-tile__name">Ícone</span>
                          </div>
                          <div class="link-sim-card">
                            <div class="link-sim-icon"
                                 [style.backgroundColor]="obtenhaFundoDecorativoDoLink(link)">
                              <img *ngIf="obtenhaImagemDoIcone(link)"
                                   [src]="obtenhaImagemDoIcone(link)" alt="" />
                              <i *ngIf="!obtenhaImagemDoIcone(link)"
                                 [class]="obtenhaIconeSelecionado(link) || obtenhaIconeDoTipo(link.tipo, link.itemType || 'link')"
                                 [style.color]="obtenhaCorDecorativaDoLink(link)"></i>
                            </div>
                            <div class="link-sim-content">
                              <span class="link-sim-title">{{ link.titulo || 'Meu link' }}</span>
                            </div>
                            <i class="fas fa-chevron-right link-sim-chevron"></i>
                          </div>
                        </button>

                        <button type="button"
                                class="link-mode-tile"
                                [class.is-active]="usarImagemNoLink(link)"
                                (click)="selecionarModoVisual(link, 'image')">
                          <div class="link-mode-tile__header">
                            <span class="link-mode-tile__radio"></span>
                            <span class="link-mode-tile__name">Imagem personalizada</span>
                          </div>
                          <div class="link-sim-card">
                            <div class="link-sim-thumb" *ngIf="temImagemDoLink(link)">
                              <img [src]="link.urlImagem" alt="" />
                            </div>
                            <div class="link-sim-thumb link-sim-thumb--empty" *ngIf="!temImagemDoLink(link)">
                              <i class="fas fa-image"></i>
                            </div>
                            <div class="link-sim-content">
                              <span class="link-sim-title">{{ link.titulo || 'Meu link' }}</span>
                            </div>
                            <i class="fas fa-chevron-right link-sim-chevron"></i>
                          </div>
                        </button>

                      </div>
                    </div>

                    <div class="form-group mb-0 link-editor__field link-editor__field--full"
                         *ngIf="usarIconeNoLink(link)">
                      <label class="link-editor__label">Ícone do link</label>
                      <div class="link-icon-picker-group">
                        <span class="link-icon-picker-group__title">Apps</span>
                        <div class="link-icon-picker">
                          <button type="button"
                                  class="link-icon-picker__option"
                                  [class.is-active]="usaIconeAutomatico(link)"
                                  (click)="selecionarIcone(link, '')">
                            <span class="link-icon-picker__radio"></span>
                            <span class="link-icon-picker__preview link-icon-picker__preview--auto">
                              <img *ngIf="obtenhaImagemDoIcone({ tipo: link.tipo, itemType: link.itemType, icone: '' })"
                                   [src]="obtenhaImagemDoIcone({ tipo: link.tipo, itemType: link.itemType, icone: '' })"
                                   alt="" />
                              <i *ngIf="!obtenhaImagemDoIcone({ tipo: link.tipo, itemType: link.itemType, icone: '' }) && obtenhaIconeDoTipo(link.tipo, link.itemType || 'link')"
                                 [class]="obtenhaIconeDoTipo(link.tipo, link.itemType || 'link')"
                                 [style.color]="obtenhaCorDoTipo(link.tipo, link.itemType || 'link')"></i>
                            </span>
                            <span class="link-icon-picker__text">
                              <strong>Padrão do tipo</strong>
                              <small>Usa o visual padrão do app</small>
                            </span>
                          </button>

                          <button type="button"
                                  class="link-icon-picker__option"
                                  *ngFor="let opcao of iconesAppsPredefinidos"
                                  [class.is-active]="obtenhaIconeSelecionado(link) === opcao.valor"
                                  (click)="selecionarIcone(link, opcao.valor)">
                            <span class="link-icon-picker__radio"></span>
                            <span class="link-icon-picker__preview"
                                  [style.backgroundColor]="!opcao.imagem ? obtenhaFundoDecorativoDoIcone(opcao.valor) : null"
                                  [style.borderColor]="!opcao.imagem ? obtenhaBordaDecorativaDoIcone(opcao.valor) : null">
                              <img *ngIf="opcao.imagem" [src]="opcao.imagem" alt="" />
                              <i *ngIf="!opcao.imagem"
                                 [class]="opcao.valor"
                                 [style.color]="obtenhaCorDecorativaDoIcone(opcao.valor)"></i>
                            </span>
                            <span class="link-icon-picker__text">
                              <strong>{{opcao.label}}</strong>
                            </span>
                          </button>
                        </div>
                      </div>

                      <div class="link-icon-picker-group">
                        <span class="link-icon-picker-group__title">Outros ícones</span>
                        <div class="link-icon-picker link-icon-picker--compact">
                          <button type="button"
                                  class="link-icon-picker__option"
                                  *ngFor="let opcao of iconesPredefinidos"
                                  [class.is-active]="obtenhaIconeSelecionado(link) === opcao.valor"
                                  [title]="opcao.label"
                                  (click)="selecionarIcone(link, opcao.valor)">
                            <span class="link-icon-picker__preview"
                                  [style.backgroundColor]="obtenhaFundoDecorativoDoIcone(opcao.valor)"
                                  [style.borderColor]="obtenhaBordaDecorativaDoIcone(opcao.valor)">
                              <i [class]="opcao.valor"
                                 [style.color]="obtenhaCorDecorativaDoIcone(opcao.valor)"></i>
                            </span>
                          </button>
                        </div>
                      </div>
                      <small class="link-editor__help">Escolha um app oficial ou um ícone simples para representar o link.</small>
                    </div>
                  </div>
                </div>

                <div class="link-editor__section" *ngIf="usarImagemNoLink(link)">
                  <div class="form-group mb-0">
                    <label class="font-weight-bold d-block">Imagem do link</label>
                    <small class="text-muted d-block mb-2">A thumb substitui o ícone e aparece como miniatura do link na bio pública.</small>
                    <div class="link-media-card">
                      <div class="link-media-card__header">
                        <div>
                          <span class="link-media-card__eyebrow">Mídia do link</span>
                          <strong class="link-media-card__title">Thumb visual do card</strong>
                        </div>
                        <span class="link-media-card__chip">1:1</span>
                      </div>

                      <div class="link-media-card__body">
                        <div class="link-upload-wrapper">
                          <app-upload-crop-imagem [objeto]="link"
                                                  prop="urlImagem"
                                                  label="Thumb do link"
                                                  ratio="1"
                                                  [resizeWidth]="300"
                                                  [minWidth]="200"
                                                  [minHeight]="200"
                                                  [widthExibir]="168"
                                                  [confirmarSalvar]="false"
                                                  uploadUrl="/upload/imagem/300">
                          </app-upload-crop-imagem>
                        </div>

                        <div class="link-media-card__aside">
                          <div class="link-media-card__status" [class.is-ready]="temImagemDoLink(link)">
                            <i class="fas" [ngClass]="temImagemDoLink(link) ? 'fa-check-circle' : 'fa-image'"></i>
                            <span>{{ temImagemDoLink(link) ? 'Thumb pronta para destaque' : 'Envie uma imagem para destacar o link' }}</span>
                          </div>

                          <div class="link-media-card__specs">
                            <span class="link-media-card__spec">Quadrada</span>
                            <span class="link-media-card__spec">JPG, PNG, GIF</span>
                            <span class="link-media-card__spec">Mín. 200x200</span>
                          </div>

                          <p class="link-media-card__hint mb-0">
                            Use artes simples, alto contraste e foco central. Essa thumb aparece como capa do link na bio pública.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="isSeparador(link)">
                <div class="link-editor__section">
                  <div class="link-editor__section-head">
                    <div>
                      <span class="link-editor__eyebrow">Organização</span>
                      <strong class="link-editor__section-title">Separador visual</strong>
                    </div>
                  </div>

                  <div class="link-editor__grid link-editor__grid--separator">
                    <div class="form-group mb-0 link-editor__field">
                      <label class="link-editor__label">Texto do separador</label>
                      <input class="form-control link-editor__input" [(ngModel)]="link.separatorText" placeholder="Ex: Peça Online">
                      <small class="link-editor__help">Opcional. Use um texto curto para nomear o bloco.</small>
                    </div>

                    <div class="separator-toggle">
                      <div>
                        <label class="link-editor__label d-block mb-1">Exibir linha</label>
                        <small class="link-editor__help">Ative a linha para separar visualmente as seções da bio.</small>
                      </div>
                      <kendo-switch [(ngModel)]="link.separatorShowLine"></kendo-switch>
                    </div>
                  </div>

                  <div class="separator-preview-admin mt-3"
                       [class.separator-preview-admin--line]="link.separatorShowLine !== false"
                       [class.separator-preview-admin--text-only]="link.separatorShowLine === false">
                    <span *ngIf="link.separatorText">{{link.separatorText}}</span>
                    <span *ngIf="!link.separatorText && link.separatorShowLine !== false">Linha horizontal</span>
                    <span *ngIf="!link.separatorText && link.separatorShowLine === false">Separador sem conteúdo</span>
                  </div>
                </div>
              </ng-container>

              <div class="alert alert-danger py-2 mt-2 mb-0" *ngIf="erroValidacaoItem">
                <i class="fas fa-exclamation-circle mr-1"></i> {{erroValidacaoItem}}
              </div>

              <div class="link-editor__footer">
                <button class="btn btn-sm btn-outline-danger link-editor__delete" (click)="confirmarExclusao(link)">
                  <i class="fas fa-trash mr-1"></i> Excluir
                </button>

                <div class="link-editor__footer-actions">
                  <button class="btn btn-sm btn-outline-secondary link-editor__secondary" (click)="cancelarEdicaoInline(link, i)">Cancelar</button>
                  <button class="btn btn-sm btn-primary link-editor__primary" (click)="salvarLinkInline(link, i)" [disabled]="salvando">
                    <i class="fas fa-save mr-1" *ngIf="!salvando"></i>
                    <i class="fas fa-spinner fa-spin mr-1" *ngIf="salvando"></i>
                    {{salvando ? 'Salvando...' : 'Salvar'}}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="preview-panel">
    <div class="preview-header mb-3 text-center">
      <span class="text-muted font-weight-bold">Preview</span>
    </div>

    <div class="preview-toggle mb-3 text-center">
      <div class="btn-group">
        <button class="btn btn-sm"
                [ngClass]="{'btn-primary': modoPreview === 'mobile', 'btn-outline-primary': modoPreview !== 'mobile'}"
                (click)="modoPreview = 'mobile'">
          <i class="fas fa-mobile-alt mr-1"></i> Mobile
        </button>
        <button class="btn btn-sm"
                [ngClass]="{'btn-primary': modoPreview === 'desktop', 'btn-outline-primary': modoPreview !== 'desktop'}"
                (click)="modoPreview = 'desktop'">
          <i class="fas fa-desktop mr-1"></i> Desktop
        </button>
      </div>
    </div>

    <div class="phone-frame" [ngClass]="{'desktop-frame': modoPreview === 'desktop'}">
      <div class="phone-notch" *ngIf="modoPreview === 'mobile'"></div>
      <div class="phone-screen">
        <iframe *ngIf="urlPreview"
                [src]="urlPreview"
                class="preview-iframe"
                frameborder="0"
                scrolling="yes">
        </iframe>
        <div *ngIf="!urlPreview" class="no-preview">
          <i class="fas fa-eye-slash fa-2x text-muted mb-2"></i>
          <p class="text-muted">Configure o slug para visualizar o preview</p>
        </div>
      </div>
      <div class="phone-home-bar" *ngIf="modoPreview === 'mobile'"></div>
    </div>

    <div class="mt-3 text-center" *ngIf="urlPreview">
      <button class="btn btn-outline-secondary btn-sm mr-2" (click)="recarregarPreview()">
        <i class="fas fa-sync-alt mr-1"></i> Atualizar Preview
      </button>
      <button class="btn btn-outline-secondary btn-sm" (click)="abrirEmNovaAba()">
        <i class="fas fa-external-link-alt mr-1"></i> Abrir Página
      </button>
    </div>
  </div>
</div>

<kendo-dialog *ngIf="exibirDialogNovoItem"
              title="Adicionar Item"
              (close)="exibirDialogNovoItem = false"
              [width]="520">
  <p class="text-muted mb-3">Escolha o tipo de item que deseja adicionar na bio:</p>
  <div class="tipo-item-grid">
    <button type="button" class="tipo-item-card" (click)="selecionarTipoDeItem('link')">
      <i class="fas fa-link"></i>
      <strong>Link</strong>
      <span>Item clicável para WhatsApp, Instagram, cardápio e outros canais.</span>
    </button>
    <button type="button" class="tipo-item-card" (click)="selecionarTipoDeItem('separator')">
      <i class="fas fa-grip-lines"></i>
      <strong>Separador</strong>
      <span>Item visual para dividir blocos da bio com texto e/ou linha.</span>
    </button>
  </div>
</kendo-dialog>

<kendo-dialog *ngIf="exibirDialogPlataformas"
              title="Adicionar Link"
              (close)="exibirDialogPlataformas = false"
              [width]="500">
  <p class="text-muted mb-3">Selecione as plataformas que deseja adicionar:</p>
  <div class="plataformas-grid">
    <div *ngFor="let tipo of tiposDeLink"
         class="plataforma-item"
         [class.selecionada]="plataformasSelecionadas.has(tipo.valor)"
         (click)="togglePlataforma(tipo.valor)">
      <div class="plataforma-icone" [style.color]="tipo.cor">
        <img *ngIf="tipo.logo" [src]="tipo.logo" class="plataforma-logo" [alt]="tipo.label" />
        <i *ngIf="!tipo.logo" [class]="tipo.icone"></i>
      </div>
      <span>{{tipo.label}}</span>
      <i class="fas fa-check-circle check-icon" *ngIf="plataformasSelecionadas.has(tipo.valor)"></i>
    </div>
  </div>
  <kendo-dialog-actions>
    <button kendoButton (click)="exibirDialogPlataformas = false">Cancelar</button>
    <button kendoButton [primary]="true" (click)="confirmarPlataformas()" [disabled]="plataformasSelecionadas.size === 0">
      <i class="fas fa-plus mr-1"></i> Adicionar ({{plataformasSelecionadas.size}})
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog *ngIf="modalDeletar"
              title="Confirmar exclusão"
              (close)="fecharModalDeletar('nao')"
              [minWidth]="250" [width]="400">
  <p class="text-center my-3">
    Deseja realmente excluir o item <strong>"{{obtenhaTituloCompacto(linkApagar)}}"</strong>?
  </p>
  <kendo-dialog-actions>
    <button kendoButton (click)="fecharModalDeletar('nao')">Cancelar</button>
    <button kendoButton (click)="fecharModalDeletar('sim')" [primary]="true" themeColor="error">
      <i class="fas fa-trash mr-1"></i> Excluir
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
